jQuery_T4NT(document).ready(function ($) {
	console.log('custom.js')

	/**
	*  Variant selection changed
	*  data-variant-toggle="{{variant.id}}"
	*/
	$(document).on("variant:changed", function (evt) {
		console.log('variant:changed')
		// console.log( evt.currentVariant );
		// $('[data-variant-toggle]').hide(0);
		// $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	});
	document.addEventListener('data-collection-open-drawer', function () {
		Shopify.analytics.publish("member-datac", {
			customerId: window.customer_id || "",
			platform: window.innerWidth > 768 ? "pc" : "mobile",
			name: 'mini_cart_open'
		});
	})

	$(window).on('cart:inited', function () {
		console.log('custom-js', window.customer?.id)
		// onColorSwatchChange()
		window.customer?.id && cartLoginBannerInit();
	})

	$(window).on('cart:updated', function () {
		console.log('custom-js', window.customer?.id)
		// onColorSwatchChange()
		window.customer?.id && cartLoginBannerInit();
	})
});
if (window.customer?.id) {
	const loginEvent = new CustomEvent('logined');
	document.dispatchEvent(loginEvent)
}

// 购物车页面初始化
if (meta.page.pageType == 'cart') {
	window.addEventListener("DOMContentLoaded", function () {
		console.log('main-cart')
		cartLoginBannerInit();
		window.handleCartChange('.t4s-main-cart')
	})
}